import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { Budget } from '../models/budgets/budget';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { PageOption } from '../models/common/pageOption';
import { environment } from '../../environments/environment';
import { BudgetFilter } from '../models/budgets/budget.filter';
import { PageOptionResult } from '../models/common/pageOptionResult';
import { RequestResult } from '../models/common/requestResult';
import { ErrorCollection } from '../models/common/errorCollection';

@Injectable()
export class BudgetService {

	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getBudget(id: string): Observable<Budget> {
		return this._http.get<Budget>(`${this.origin}/api/budgets/${id}`)
			.pipe(
				tap(x => this.log(`getBudget: id=${id}`)),
				catchError(this._logService.handleError<Budget>('getBudget'))
			);
	}

	getBudgetList(filter: PageOption<BudgetFilter>): Observable<PageOptionResult<Budget>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<Budget>>(`${this.origin}/api/budgets/${param}`)
			.pipe(
				tap(x => this.log(`getBudgetsList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<Budget>>('getBudgetsList'))
			);
	}

	addBudget(budget: Budget): Observable<RequestResult<Budget>> {
		return this._http.post<RequestResult<Budget>>(`${this.origin}/api/budgets`, JSON.stringify(budget))
			.pipe(
				tap(x => this.log(`addBudget: id=${budget.id}`)),
				catchError(this._logService.handleError<RequestResult<Budget>>('addBudget'))
			);
	}

	updateBudget(budget: Budget): Observable<RequestResult<Budget>> {
		return this._http.put<RequestResult<Budget>>(`${this.origin}/api/budgets/${budget.id}`, JSON.stringify(budget))
			.pipe(
				tap(x => this.log(`updateBudget: id=${budget.id}`)),
				catchError(this._logService.handleError<RequestResult<Budget>>('updateBudget'))
			);
	}

	getTotalBudget(): Observable<number> {
		return this._http.get<number>(`${this.origin}/api/budgets/total`)
			.pipe(
				tap(x => this.log(`updateBudget`)),
				catchError(this._logService.handleError<number>('updateBudget'))
			);
	}

	deleteBudget(id: number): Observable<ErrorCollection> {
		return this._http.delete<ErrorCollection>(`${this.origin}/api/budgets/${id}`)
			.pipe(
				tap(x => this.log(`deleteBudget: id=${id}`)),
				catchError(this._logService.handleError<ErrorCollection>('deleteBudget'))
			);
	}

	private log(message: string) {
		this._messagesService.add('BudgetService: ' + message);
	}

}



// WEBPACK FOOTER //
// ./src/app/services/budget.service.ts